import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { useParams, useLocation } from 'react-router-dom'

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';





function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));




const AboutEvrfy = () =>{
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const About = () => {
     
                  
    }
    return(
        <div className="container ">
          <div className="vrfy-section page page-about">
            <h1>About E-Vrfy</h1>
            <p>
              E-vrfy is the Judiciary’s Document Authentication and Verification system. 
              With E-vrfy, any organisation or person who needs to verify a Grant of Probate or Letters of Administration will be able to do so using the online E-vrfy portal.
            </p>

            <p>E-vrfy is another step toward extensive digitisation of records to enable faster searches 
              and e-filing as well as with insistence on real-time data entry to ensure that online records are complete. 
            </p>
            <p>
              As of November 30, 2021, grants of probate and letters of administration will be issued electronically and may be authenticated by E-vrfy.
            </p>
          </div>
 
        </div>
    );




};



export default AboutEvrfy;

